import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n';
import { useAuth } from './AuthContext';

export default function RequireAuth({ children, titleKey = 'authPrompt.title', copyKey = 'authPrompt.copy' }) {
  const { isAuthenticated, requestLogin } = useAuth();
  const { t } = useI18n();

  useEffect(() => {
    if (isAuthenticated) return;
    requestLogin({ title: t(titleKey), copy: t(copyKey) });
  }, [copyKey, isAuthenticated, requestLogin, t, titleKey]);

  if (isAuthenticated) return children;

  return (
    <div className="ct-card ct-empty ct-auth-required">
      <i className="ph ph-lock-key"></i>
      <h2>{t(titleKey)}</h2>
      <p>{t(copyKey)}</p>
      <button type="button" className="btn btn-dark" onClick={() => requestLogin({ title: t(titleKey), copy: t(copyKey) })}>
        {t('authPrompt.signIn')}
      </button>
      <Link to="/" className="ct-text-link">{t('detail.back')}</Link>
    </div>
  );
}
